import React, { Fragment, FunctionComponent } from 'react';
import { CustomArticleSlugTypes } from 'types/global';
import { FeatureLists, HeroImageTop, HeroSimple, Recruitment, RecruitmentSteps, Workers } from 'components/containers';
import { PageWrapper } from 'components/presentional';
import { usePages } from 'hooks';
import { useRouteTranslations } from 'utils';
import { WPAcfJoinUs } from 'types/acf';
import { WPSimplePage } from 'types/pages';
import { Block } from 'components/elements';

interface OwnProps {}

type JoinUsPageProps = Omit<JSX.IntrinsicElements['article'], 'children'> & OwnProps;

const JoinUsPage: FunctionComponent<JoinUsPageProps> = props => {
  const JOIN_US_PAGE_SLUG_TYPE: CustomArticleSlugTypes = 'join_us';
  const { translateSlug } = useRouteTranslations();
  const { data: page, loading } = usePages<WPSimplePage<WPAcfJoinUs>>({ slug: translateSlug(JOIN_US_PAGE_SLUG_TYPE) });
  const [customPage] = page || [];

  if (!customPage) {
    return null;
  }

  const {
    acf: { heroImageTop, recruitment, heroSimple, workers, featureLists, recruitmentSteps },
  } = customPage;

  return (
    <PageWrapper title={customPage?.yoast_title} meta={customPage?.yoast_meta} loading={loading} name={JOIN_US_PAGE_SLUG_TYPE}>
      {page && (
        <Fragment>
          <Block data-module="join-us-page" />
          {heroImageTop && <HeroImageTop data={heroImageTop} />}
          {recruitment && <Recruitment data={recruitment} />}
          {workers && <Workers data={workers} />}
          {featureLists && <FeatureLists data={featureLists} />}
          {heroSimple && <HeroSimple data={heroSimple} />}
          {recruitmentSteps && <RecruitmentSteps data={recruitmentSteps} />}
        </Fragment>
      )}
    </PageWrapper>
  );
};

export default JoinUsPage;
